import styled from 'styled-components';
import { TransparentButton } from '../transparent-button/TransparentButton';
import Typography from '../typography/Typography';
export const CopyButton = styled(TransparentButton) `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.7rem 1.2rem;
  border-radius: ${({ theme }) => theme.borderRadius.highL};
  background-color: ${({ theme, status, backgroundColor }) => {
    const statusColor = status
        ? theme.colors.interactive.brandColor
        : theme.colors.interactive.secondary;
    return backgroundColor ?? statusColor;
}};
`;
export const ImgContainer = styled.div `
  display: flex;
  align-items: center;
`;
export const CustomTypography = styled(Typography) `
  margin-right: 0.5rem;
`;
//# sourceMappingURL=styles.js.map